import { AxiosPromise } from 'axios';
import courseLocation, { CourseLocation } from '../model/courseLocation';
import { instance, URLS } from '.';

export interface BackendCourseLocation {
  getCourseLocationsByCourseId(
    courseId: string
  ): AxiosPromise<CourseLocation[]>;
  postMultipleCourseLocations(
    courseId: string,
    courseLocations: CourseLocation[]
  ): AxiosPromise;
}

export const defaultBackendCourseLocation: BackendCourseLocation = {
  getCourseLocationsByCourseId(
    courseId: string
  ): AxiosPromise<CourseLocation[]> {
    const url = `${URLS.courseLocations}/GetByCourseId/${courseId}`;
    return instance.get<CourseLocation[]>(url);
  },
  postMultipleCourseLocations(
    courseId: string,
    courseLocations: CourseLocation[]
  ): AxiosPromise {
    const url = `${URLS.courseLocations}/AddMultiple`;
    return instance.post(url, {
      CourseId: courseId,
      CourseLocations: courseLocations.map(courseLocation.toAPI),
    });
  },
};
